import AddToFavoritesButton from './addtofavoritesbutton'

export default AddToFavoritesButton
